import { gql } from '@apollo/client';

export const getStudentActivityEvents = gql`
  query getStudentActivityEvents($userId: uuid!) {
    user(where: { id: { _eq: $userId } }, limit: 1) {
      id
      created_at
      given_name
      family_name
    }
    registration(
      where: { user_id: { _eq: $userId } }
      order_by: { created_at: desc }
    ) {
      id
      event_id
      created_at
      updated_at
      confirmed_at
      type
      model_session_purchase_id
      event {
        id
        detail {
          title
        }
      }
    }
    online_registration(
      where: { user_id: { _eq: $userId } }
      order_by: { created_at: desc }
    ) {
      id
      created_at
      coassemble_course_id
      data
    }
    payment(
      where: { user: { _eq: $userId }, status: { _eq: "complete" } }
      order_by: { created_at: desc }
    ) {
      id
      amount
      created_at
      status
    }
    certificate(
      where: { user_id: { _eq: $userId } }
      order_by: { created_at: desc }
    ) {
      id
      created_at
      url
      event {
        detail {
          title
        }
      }
    }
  }
`;
